import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { GatewayCommissioningStore } from '@store';

@Injectable()
export class GatewayCommissioningGuardService {
  constructor(private gcStore: GatewayCommissioningStore) {}

  canActivate(): Observable<boolean> {
    return this.gcStore.isGatewayCommissioningAvailable$.pipe(
      filter((res) => !res.isLoading),
      map((res) => res.isAvailable)
    );
  }
}
